import type { AccountInfo, SilentRequest } from '@azure/msal-browser'
import {
  InteractionRequiredAuthError,
  LogLevel,
  NavigationClient,
  PublicClientApplication,
  type NavigationOptions,
} from '@azure/msal-browser'
import type { Router } from 'vue-router'
export const scopes = ['openid', import.meta.env.VITE_AUTH_SCOPE]

// type
export type MaybeAccount = AccountInfo | null
function getAuthority(authority: string) {
  return `https://${import.meta.env.VITE_AUTH_TENANT_NAME}.b2clogin.com/${import.meta.env.VITE_AUTH_TENANT_NAME}.onmicrosoft.com/${authority}`
}
/**
 * MSAL instance
 */
export const msal = new PublicClientApplication({
  // required
  auth: {
    clientId: import.meta.env.VITE_AUTH_CLIENT_ID,
    authority: getAuthority(import.meta.env.VITE_AUTH_SIGN_IN_POLICY),
    knownAuthorities: [import.meta.env.VITE_AUTH_KNOWN_AUTHORITY],
    redirectUri: import.meta.env.VITE_AUTH_REDIRECT_URI,
  },

  // optional
  system: {
    loggerOptions: {
      logLevel: LogLevel.Info,
      // loggerCallback: (level, message, containsPii) => {
      //   if (containsPii) {
      //     return
      //   }
      //   switch (level) {
      //     case LogLevel.Error:
      //       console.error(message)
      //       return
      //     case LogLevel.Info:
      //       console.info(message)
      //       return
      //     case LogLevel.Verbose:
      //       console.debug(message)
      //       return
      //     case LogLevel.Warning:
      //       console.warn(message)
      //       return
      //   }
      // },
      // piiLoggingEnabled: false,
    },
  },
})

export async function getMsalAccessToken() {
  const request: SilentRequest = {
    scopes,
  }
  try {
    const res = await msal.acquireTokenSilent(request)
    return res.accessToken
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      msal.acquireTokenRedirect(request)
    } else {
      throw error
    }
  }
}
export async function editMsalProfile() {
  msal.loginRedirect({
    authority: getAuthority(import.meta.env.VITE_AUTH_EDIT_PROFILE_POLICY),
    loginHint: msal.getActiveAccount()?.username,
    scopes: [],
    redirectStartPage: '/profile',
  })
}

export async function loginRedirect(returnPath: string = '/') {
  return await msal.loginRedirect({
    scopes: scopes,
    redirectStartPage: returnPath,
  })
}
export async function logoutRedirect() {
  return await msal.logoutRedirect({
    postLogoutRedirectUri: '/',
  })
}

export function getValidAccount() {
  const accounts = msal.getAllAccounts()
  return accounts.find(
    x => x.idTokenClaims?.acr === import.meta.env.VITE_AUTH_SIGN_IN_POLICY.toLowerCase(),
  )
}

export class VueNavigationClient extends NavigationClient {
  private router: Router

  constructor(router: Router) {
    super()
    this.router = router
  }

  /**
   * Navigates to other pages within the same web application
   * You can use the useHistory hook provided by react-router-dom to take advantage of client-side routing
   * @param url
   * @param options
   */
  async navigateInternal(url: string, options: NavigationOptions) {
    console.log('navigateInternal', url, options)
    const relativePath = url.replace(window.location.origin, '')
    if (options.noHistory) {
      this.router.replace(relativePath)
    } else {
      this.router.push(relativePath)
    }

    return false
  }
}
